export default {
    ["AUTH_REQUEST"]: (state) => {
        state.status = "loading";
    },
    ["AUTH_SUCCESS"]: (state, { user, name, token, phoneNumber }) => {
        state.status = "success";
        state.token = token;
        state.user = user;
        state.name = name;
        state.phoneNumber = phoneNumber;
    },
    ["AUTH_LOGOUT"]: (state) => {
        state.status = "";
        state.token = "";
        state.user = "";
        state.name = "";
        state.phoneNumber = "";
    },
    ["AUTH_ERROR"]: (state) => {
        state.status = "error";
    },
};
